import DuLieuMonAn from "../../components/du_lieu_mon_an/DuLieuMonAn";

const FBSiteMap = [
  {
    name: "Dữ liệu món ăn",
    path: "du lieu mon an",
    element: <DuLieuMonAn />,
  },
];

export default FBSiteMap;
